import React, {ReactNode, createContext} from 'react';
import { CustomerContext, CustomerHistory, GetCustomerHistoryResponse, Tenant, VermittlerDaten } from '../../types/apimodel';
import useCustomerHistoryData from '../hooks/useCustomerHistoryData';

interface Props {
    children?: ReactNode
}

export interface CustomerData {
    customer?: CustomerContext,
    tenant?: Tenant,
    reportData?: CustomerHistory[],
    loading: boolean,
    error: string | undefined,
    vermittlerDaten?: VermittlerDaten,
    resetError: () => void
}

export const CustomerDataContext = createContext({
    customer: undefined,
    tenant: undefined,
    reportData: [],
    loading: false,
    error: undefined,
    vermittlerDaten: undefined,
    resetError: () => {}
} as CustomerData);


const CustomerDataProvider : React.FC<Props> = ({children}) => {
    const [loading, error, customerContextData, resetError] = useCustomerHistoryData();
    
    const {tenant, list, customer, vermittlerDaten} = customerContextData??{} as GetCustomerHistoryResponse;
    const reportData = list?.value??[] as CustomerHistory[];

    return <CustomerDataContext.Provider value={{
        customer,
        tenant,
        reportData,
        loading,
        error,
        vermittlerDaten,
        resetError
    }}>{children}</CustomerDataContext.Provider>
}

export default CustomerDataProvider;